export const ARTIST_GROUP_ID = [
  { label: "Cast", value: 1 },
  { label: "Crew", value: 2 },
];